import Notification from 'flarum/forum/components/Notification';
import app from 'flarum/forum/app';

export default class SarahLevelUpNotification extends Notification {
  icon() {
    return 'fas fa-star';
  }

  href() {
    const user = this.attrs.notification.subject();
    return user ? app.route('user', user) : '#';
  }

  content() {
    const data = this.attrs.notification.content() || {};
    return data.summary || '等级升级';
  }

  excerpt() {
    const data = this.attrs.notification.content() || {};
    return (data.oldLevel || '') + ' → ' + (data.newLevel || '');
  }
}
